var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTeams(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 127 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#teams_svg__clip0_182_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.584 44.464h32.804c3.1 0 5.612 2.522 5.612 5.633v29.99c0 11.431-9.234 20.699-20.624 20.699h-.098c-11.39.002-20.625-9.264-20.627-20.697V47.41a2.952 2.952 0 01.859-2.083 2.932 2.932 0 012.074-.862zM110.756 38.536c7.34 0 13.291-5.972 13.291-13.34 0-7.366-5.951-13.339-13.291-13.339-7.34 0-13.29 5.973-13.29 13.34s5.95 13.34 13.29 13.34z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.407 38.536c10.603 0 19.198-8.627 19.198-19.268S80.01 0 69.407 0 50.21 8.627 50.21 19.268c0 10.642 8.595 19.268 19.198 19.268zM95.005 44.464h-54.15c-3.062.077-5.484 2.627-5.413 5.7V84.37c-.428 18.444 14.111 33.75 32.488 34.202 18.377-.452 32.916-15.758 32.489-34.202V50.165c.071-3.074-2.352-5.624-5.414-5.7z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.884 44.464v47.933a5.471 5.471 0 01-.93 3.015 5.441 5.441 0 01-2.437 1.995 5.213 5.213 0 01-2.038.415H38.04a35.38 35.38 0 01-1.034-2.964 36.218 36.218 0 01-1.566-10.494V50.156c-.07-3.069 2.348-5.615 5.405-5.691h30.038z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.93 44.464v50.898c0 .702-.14 1.398-.413 2.045a5.453 5.453 0 01-1.987 2.446 5.419 5.419 0 01-3.005.933H39.43a38.446 38.446 0 01-1.388-2.964 29.428 29.428 0 01-1.033-2.964 36.222 36.222 0 01-1.566-10.494V50.156c-.07-3.069 2.348-5.615 5.405-5.691H67.93z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.93 44.464v44.969c-.022 2.986-2.429 5.402-5.405 5.425H37.007a36.218 36.218 0 01-1.565-10.494V50.156c-.071-3.069 2.347-5.615 5.405-5.691H67.93z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.977 44.464v44.969c-.023 2.986-2.43 5.402-5.405 5.425H37.007a36.218 36.218 0 01-1.565-10.494V50.156c-.071-3.069 2.347-5.615 5.405-5.691h24.13z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.884 29.14v9.336c-.502.03-.975.06-1.477.06-.502 0-.975-.03-1.477-.06a16.162 16.162 0 01-2.953-.474 19.172 19.172 0 01-8-4.06 19.265 19.265 0 01-5.291-7.263 16.469 16.469 0 01-.945-2.965h14.738c2.98.012 5.394 2.434 5.405 5.425z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.93 32.103v6.373a16.163 16.163 0 01-2.953-.474 19.172 19.172 0 01-8-4.06 19.266 19.266 0 01-5.29-7.263h10.838c2.98.01 5.394 2.433 5.405 5.424z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.93 32.103v6.373a16.163 16.163 0 01-2.953-.474 19.172 19.172 0 01-8-4.06 19.266 19.266 0 01-5.29-7.263h10.838c2.98.01 5.394 2.433 5.405 5.424z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.977 32.103v5.9a19.172 19.172 0 01-8-4.061 19.266 19.266 0 01-5.291-7.264h7.886c2.98.012 5.394 2.434 5.405 5.425z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.414 26.678h54.148c2.991 0 5.415 2.433 5.415 5.434v54.347c0 3-2.424 5.434-5.414 5.434H5.413C2.424 91.893 0 89.46 0 86.459V32.112c0-3.002 2.424-5.434 5.414-5.434z",
    fill: "url(#teams_svg__paint0_linear_182_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.736 47.363H35.911v29.584h-6.896V47.363H18.241v-5.739h28.495v5.74z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams_svg__paint0_linear_182_3",
    x1: 1128.78,
    y1: -397.872,
    x2: 5392.22,
    y2: 6959.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "teams_svg__clip0_182_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h127v119H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default ForwardRef;